export default __webpack_public_path__ + "static/tte-1-d509aefc2e01c1553ee5727d1a68eb9a.png";